<template>
	<div class="share" @click="shareClose">
		<div class="share__box">
			<div class="share__body">
				<div class="global_pointer" @click="copyUrl">
					<img :src="require('@/assets/imgs/share/link.png')" />
					<span>{{ $t("message.room.copyUrl") }}</span>
				</div>

				<template v-if="$i18n.locale === 'en'">
					<div class="global_pointer" @click="emailShare">
						<img :src="require('@/assets/imgs/share/email.png')" />
						<span>{{ $t("message.room.shareEmail") }}</span>
					</div>
					<div
						class="sms global_pointer"
						@click="smsShare"
						v-if="
							sharePosition == 'Room' && shareInfo.liveStatus == 1
						"
					>
						<img :src="require('@/assets/imgs/share/sms.png')" />
						<span>{{ $t("message.room.shareSms") }}</span>
					</div>
					<div
						class="facebook global_pointer"
						@click="fbShare"
						v-if="
							sharePosition == 'Room' && shareInfo.liveStatus == 1
						"
					>
						<img
							:src="require('@/assets/imgs/share/facebook.png')"
						/>
						<span>{{ $t("message.room.shareFB") }}</span>
					</div>
					<div class="global_pointer" @click="download">
						<img :src="require('@/assets/imgs/share/down.png')" />
						<span>Download App</span>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { plateForm, getQueryObj } from "@/utils";
import { LIVESTATUS, LIVESOURCE, LIVEMSGSOURCE } from "@/assets/js/const";
import api from "@/api/api_list";
import OpenApp from "@/common/openApp";
const openApp = new OpenApp();
export default {
	props: {
		shareInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
		sharePosition: {
			type: String,
			default: () => {
				return "Room";
			},
		},
	},
	data() {
		return {
			shareUrl: null
		}
	},

	created() {
		let queryObj = getQueryObj();
		let userInfo = this.$storage.get('user_info') || null;
		if( userInfo ){
			queryObj.code = userInfo.inviteCode; 
			queryObj.userNum = userInfo.userNum;
			queryObj.userName = userInfo.userName 
		}
		delete queryObj.jumpType;
		delete queryObj.jumpId;
		delete queryObj.uid;

		let _query = '';

		for(var k in queryObj){
			if( _query === '' ){
				_query += `${k}=${ queryObj[k] }`
			}else{
				_query += `&${k}=${ queryObj[k] }`
			}
		}

		this.shareUrl = location.origin + location.pathname+ '?' + encodeURI(_query);
	},

	methods: {
		shareClose() {
			this.$emit("shareClose", false);
		},
		copyUrl() {
			let textArea = document.createElement("textarea");
			textArea.style.position = "fixed";
			textArea.style.top = "0";
			textArea.style.left = "0";
			textArea.style.width = "2em";
			textArea.style.height = "2em";
			textArea.style.padding = "0";
			textArea.style.border = "none";
			textArea.style.outline = "none";
			textArea.style.boxShadow = "none";
			textArea.style.background = "transparent";
			textArea.value = this.shareUrl;
			document.body.appendChild(textArea);
			textArea.select();

			try {
				document.execCommand("copy");
				this.$toast(this.$t("message.room.copySuccess"));
			} catch (err) {
				this.$toast(this.$t("message.room.copyError"));
			}

			document.body.removeChild(textArea);
		},
		emailShare() {
			let that = this;

			const emailAction = function (shortUrl) {
				let userInfo = that.$storage.get("user_info") || null;
				let subject = `Watch ${that.shareInfo.hostName}'s "${that.shareInfo.liveName}" livestream on ShopShops!`;

				let desc = "";
				if (
					that.shareInfo.liveStatus == LIVESTATUS.PREVIEW ||
					that.shareInfo.liveStatus == LIVESTATUS.LIVE
				) {
					desc = ` ${that
						.$moment(new Date(that.shareInfo.bookStartTime))
						.format("[on] MMMM D [at] HH:mmA")}`;
				}
				// let body = `Watch ${that.shareInfo.hostName}'s "${that.shareInfo.liveName}" livestream on ShopShops${desc}. Use my referral code ${userInfo.inviteCode} when you sign up to earn $25 ShopShops cash! `;
				let body = `Shop with me at ShopShops! Use my referral code ${userInfo.inviteCode} when you sign up to get $75 worth of shopping credit. `;
				shortUrl = encodeURIComponent(shortUrl);
				window.location.href = `mailto:?subject=${subject}&body=${body}%0d%0d%0d%0d${shortUrl}`;
			};

			const goodsEmail = function (shortUrl) {
				let userInfo = that.$storage.get("user_info") || null;
				shortUrl = encodeURIComponent(shortUrl);

				let subject = `${that.shareInfo.name}`;
				// let body = `Check out ${that.shareInfo.name} on ShopShops. Use my referral code ${userInfo.inviteCode} when you sign up to earn $25 ShopShops cash. %0d%0d%0d%0d${shortUrl}`;
				let body = `Shop with me at ShopShops! Use my referral code ${userInfo.inviteCode} when you sign up to get $75 worth of shopping credit. ${shortUrl}`;
				window.location.href = `mailto:?subject=${subject}&body=${body}`;
			};

			let url = this.shareUrl;

			api.create_short_url({ content: url }).then((res) => {
				if (res.code === 0) {
					let shortUrl = res.result;
					if (this.sharePosition == "GoodDetail") {
						goodsEmail(shortUrl);
						return;
					}
					emailAction(shortUrl);
				}
			});
		},
		async fbShare() {
			const fb = function (params) {
				window.FB.ui(
					{
						method: "share",
						href: params,
					},
					function (response) {
						if (response && !response.error_message) {
							console.log("Posting completed.");
						} else {
							console.log("Error while posting.");
						}
					}
				);
			};

			// let url = location.href.split("#")[0];
			// let url = this.shareInfo.shortUrl ? encodeURIComponent(this.shareInfo.shortUrl) : window.location.href;
			fb( this.shareUrl );
		},
		smsShare() {
			let that = this;
			const sms = function (shortUrl) {
				let userInfo = that.$storage.get("user_info") || null;

				let desc = "";
				if (
					that.shareInfo.liveStatus == LIVESTATUS.PREVIEW ||
					that.shareInfo.liveStatus == LIVESTATUS.LIVE
				) {
					desc = ` ${that
						.$moment(new Date(that.shareInfo.bookStartTime))
						.format("[on] MMMM D [at] HH:mmA")}`;
				}

				let shareContent = `Watch ${that.shareInfo.hostName}'s "${that.shareInfo.liveName}" livestream on ShopShops${desc}. Use my referral code ${userInfo.inviteCode} when you sign up to earn $25 ShopShops cash!${shortUrl}`;
				if (plateForm().isIOS) {
					window.location.href = "sms:&body=" + shareContent;
				} else if (plateForm().isAndroid) {
					window.location.href = "sms:?body=" + shareContent;
				}
			};

			let url = this.shareUrl;
			api.create_short_url({ content: url }).then((res) => {
				if (res.code === 0) {
					let shortUrl = res.result;
					shortUrl = encodeURIComponent(shortUrl);
					sms(shortUrl);
				}
			});
		},
		download() {
			openApp.download();
		},
	},
};
</script>

<style scoped lang="less">
.share {
	width: 100%;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 101;
	background: rgba(0, 0, 0, 0);
	overflow: auto;
	&__box {
		width: 100%;
		height: 113.99px;
		position: fixed;
		bottom: 0;
		background: rgba(22, 26, 26, 0.9);
		z-index: 102;
		overflow-x: scroll;
		overflow-y: hidden;
	}
	&__body {
		width: 420px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		> div {
			float: left;
			margin-top: 27px;
			margin-left: 5px;
			width: 76px;
			font-size: 11px;
			color: #f2f2f2;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			img {
				width: 42px;
				height: 42px;
			}
		}
	}
}
</style>
